
import './index.scss';

import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import HelloModal from 'common/components/hello-modal';
import logger from 'common/logger';
import { ErrorMessage } from 'common/messages';
import errorCodes from 'signer/api/errors';
import loadingImg from 'images/v2/common/loader_@2x.gif';


const hsMessages = defineMessages({
  qesFailed: {
    id: '',
    description: 'error message in modal of signer flow, shows when tyring to finish the qualified signature request',
    defaultMessage: 'Qualified signature request failed',
  },

  finishWithIDnow: {
    id: 'signer.qualified.modal.completeButton',
    description: 'button text in modal of signer flow, when cliked finish qualified signature process with IDnow',
    defaultMessage: 'Finish with IDnow',
  },

  cancelQES: {
    id: 'signer.qualified.modal.cancelButton',
    description: 'button text in modal of singer flow, when clicked closes the modal',
    defaultMessage: 'Cancel',
  },

  almostDone: {
    id: 'signer.qualified.modal.title',
    description: 'title text of modal in signer flow, when starting the qualified signature request',
    defaultMessage: 'Almost done!',
  },

  content: {
    id: 'signer.qualified.modal.description',
    description: 'text in modal of signer flow, informing sender that they need to finish identity verification with IDnow',
    defaultMessage: 'For this document to have a Qualified eSignature, you will need to finish identity verification with IDnow. <a>Learn more</a>',
  },

  loadingIdnow: {
    id: 'signer.qualified.modal.loadingText',
    description: 'loading text of modal in signer flow, when redirecting signer to idnow page',
    defaultMessage: 'Please wait a moment while we redirect you to IDnow.',
  },
});


class ConfirmQualifiedSignature extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };

    this.complete = this.complete.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    logger.track('ConfirmQES.componentDidMount');
  }

  complete() {
    if (!this.state.isLoading) {
      this.setState({
        isLoading: true,
      });

      const { signatureRequest, router, notifier, intl } = this.props.app;
      this.listeningAsyncResponse = true;
      logger.track('ConfirmQES.continue');
      signatureRequest
        .complete()
        .then((response) => {
          this.props.app.completeQesUrl = response.qes_url;
          router.displayFullScreenModal('completeQualifiedSignature');
        })
        .catch(() => {
          this.listeningAsyncResponse = false;
          this.setState({
            isLoading: false,
          });
          this.close();
          const error = new Error(intl.formatMessage(hsMessages.qesFailed));
          error.code = errorCodes.SERVER;
          notifier.notify(ErrorMessage.create(error, this));
        });
    }
  }

  close() {
    this.props.app.router.hideFullScreenModal();
  }

  render() {
    const { intl } = this.props;

    const buttons = [
      { type: 'secondary', text: intl.formatMessage(hsMessages.cancelQES), onClick: this.close },
      { type: 'primary', text: intl.formatMessage(hsMessages.finishWithIDnow), onClick: this.complete },
    ];

    const loader = (
      <div className="confirm-qes__loader__div">
        <p className="confirm-qes__description">{intl.formatMessage(hsMessages.loadingIdnow)}</p>
        <img className="confirm-qes__loader__img" src={loadingImg} />
      </div>
    );

    const content = (
      <div>
        {intl.formatMessage(hsMessages.content, {
          a: (...chunks) => (
            <a href="https://faq.hellosign.com/hc/en-us/articles/360056581532-Qualified-eSignature-" target="_blank" rel="noopener noreferrer">
              {chunks}
            </a>
          ),
        })}
      </div>
    );

    return (
      <HelloModal
        isOpen={true}
        shouldCloseOnOverlayClick={false}
        showCloseIcon={!this.listeningAsyncResponse}
        onRequestClose={this.close}
        buttons={!this.listeningAsyncResponse && buttons}
        contentLabel={!this.listeningAsyncResponse && intl.formatMessage(hsMessages.almostDone)}
      >
        {this.listeningAsyncResponse
          ? loader
          : content
        }
      </HelloModal>
    );
  }
}

export default injectIntl(ConfirmQualifiedSignature);
